module.exports = __webpack_public_path__ + "img/framework.2adf9f16.png";